// extracted by mini-css-extract-plugin
export default {"container":"CourseContentTree_container__6tlKy"};